import JobDetails from './JobDetails'
export { JobDetailsSkeleton } from './JobDetailsSkeleton'
export default JobDetails
